module.exports = __webpack_public_path__ + "static/img/doctor.3a5d1253.png";